import shave from 'shave';
import { debounce } from 'lodash';
import smoothscroll from 'smoothscroll-polyfill';

class BrixModuleLatestPostsList {
  static init(...parameters) {
    return new BrixModuleLatestPostsList(...parameters);
  }

  constructor(selector) {
    this.selector = selector;

    this.scrollWrapper = this.selector.querySelector('.scroll-wrapper');

    if (this.scrollWrapper) {
      this.scrollIndicator = this.selector.querySelector('.scroll-indicator');
      this.scrollIndicatorInner = this.selector.querySelector('.scroll-indicator .inner');
      this.latestPostsWrapper = this.selector.querySelector('.latest-posts');
      this.posts = this.selector.querySelectorAll('.post');
      this.firstPost = this.latestPostsWrapper.querySelector('.post');
      this.scrollButtonsWrapper = this.selector.querySelector('.scroll-buttons');
      this.earlierDatesButton = this.selector.querySelector('.scroll-button.-earlier');
      this.laterDatesButton = this.selector.querySelector('.scroll-button.-later');
      this.moreEventsTitles = this.latestPostsWrapper.querySelectorAll('.post .title');
      this.moreEventsExcerpts = this.latestPostsWrapper.querySelectorAll('.post .excerpt');

      smoothscroll.polyfill();
      this.toggleScrollControls();
      this.truncateEventTitle();
      this.updateAlignment();

      window.addEventListener('resize', debounce(() => {
        this.toggleScrollControls();
        this.truncateEventTitle();
      }, 50));

      if (this.earlierDatesButton) {
        this.earlierDatesButton.addEventListener('click', () => {
          this.latestPostsWrapper.scrollBy({
            top: 0,
            left: -416,
            behavior: 'smooth',
          });
        });
      }

      if (this.earlierDatesButton) {
        this.laterDatesButton.addEventListener('click', () => {
          this.latestPostsWrapper.scrollBy({
            top: 0,
            left: 416,
            behavior: 'smooth',
          });
        });
      }

      this.latestPostsWrapper.addEventListener('scroll', debounce(() => {
        this.toggleButtonVisibility();

        const scrollPercentage = (100 * this.latestPostsWrapper.scrollLeft)
          / (this.latestPostsWrapper.scrollWidth - this.latestPostsWrapper.clientWidth);
        this.scrollIndicatorInner.style.left = `calc(${scrollPercentage}% - ${98 * (scrollPercentage / 100)}px`;
      }, 50));

      window.addEventListener('resize', debounce(() => {
        this.updateAlignment();
      }, 50));
    }
  }

  toggleScrollControls() {
    if (this.latestPostsWrapper && this.scrollWrapper) {
      if (this.latestPostsWrapper.scrollWidth > this.scrollWrapper.offsetWidth) {
        this.scrollIndicator.classList.remove('-hide');
        this.toggleButtonVisibility();
        this.latestPostsWrapper.addEventListener('scroll', this.onDateWrapperScroll());
      } else {
        this.latestPostsWrapper.removeEventListener('scroll', this.onDateWrapperScroll());
        this.scrollIndicator.classList.add('-hide');
        this.earlierDatesButton.classList.remove('-show');
        this.laterDatesButton.classList.remove('-show');
      }
    }
  }

  onDateWrapperScroll() {
    this.toggleButtonVisibility();

    const scrollPercentage = (100 * this.latestPostsWrapper.scrollLeft)
      / (this.latestPostsWrapper.scrollWidth - this.latestPostsWrapper.clientWidth);
    this.scrollIndicatorInner.style.left = `calc(${scrollPercentage}% - ${98 * (scrollPercentage / 100)}px`;
  }

  toggleButtonVisibility() {
    this.laterDatesButton.classList.add('-show');

    if (this.latestPostsWrapper.scrollLeft > 1 && !this.earlierDatesButton.classList.contains('-show')) {
      this.earlierDatesButton.classList.add('-show');
    }

    if (this.latestPostsWrapper.scrollLeft < 1 && this.earlierDatesButton.classList.contains('-show')) {
      this.earlierDatesButton.classList.remove('-show');
    }

    if (this.latestPostsWrapper.scrollLeft > 1 && !this.earlierDatesButton.classList.contains('-show')) {
      this.laterDatesButton.classList.add('-show');
    }

    if (this.latestPostsWrapper.scrollLeft + this.latestPostsWrapper.offsetWidth
      >= this.latestPostsWrapper.scrollWidth && this.earlierDatesButton.classList.contains('-show')) {
      this.laterDatesButton.classList.remove('-show');
    }

    if (this.latestPostsWrapper.scrollLeft + this.latestPostsWrapper.offsetWidth
      <= this.latestPostsWrapper.scrollWidth && !this.earlierDatesButton.classList.contains('-show')) {
      this.laterDatesButton.classList.add('-show');
    }
  }

  truncateEventTitle() {
    Array.from(this.moreEventsTitles).forEach((title) => {
      shave(title, 62);
    });
    Array.from(this.moreEventsExcerpts).forEach((excerpt) => {
      shave(excerpt, 92);
    });
  }

  updateAlignment() {
    if (this.latestPostsWrapper.clientWidth <= this.scrollWrapper.clientWidth
      && this.posts.length * this.firstPost.clientWidth
      > this.latestPostsWrapper.clientWidth) {
      this.latestPostsWrapper.classList.add('-align-left');
    } else {
      this.latestPostsWrapper.classList.remove('-align-left');
    }

    if (this.scrollWrapper.clientWidth === window.innerWidth) {
      this.latestPostsWrapper.classList.add('-with-inner-padding');
    }


    // NOTE: 240 = (button width + margins) * 2
    if (window.innerWidth - this.scrollWrapper.clientWidth > 200) {
      this.scrollButtonsWrapper.style.width = `${this.scrollWrapper.clientWidth + 200}px`;
    } else {
      this.scrollButtonsWrapper.style.width = '';
    }
  }
}

// Register class
window.brix && window.brix.registerBlock && window.brix.registerBlock('brix-latest-posts-list', BrixModuleLatestPostsList.init);
